module.exports = __webpack_public_path__ + "img/0bded5358f7d902aeae3dee90cf73986.png";